import React, { Suspense, useEffect } from "react";
import { useQueryLoader } from "react-relay";

import { Loader } from "@whoosh/design-system/src/components/display";

import {
  ProfileUpdateFormQueryRenderer,
  ProfileUpdateFormQueryRendererQueryString,
} from "./ProfileUpdateFormQueryRenderer";
import { ProfileUpdateFormQueryRendererQuery } from "./__generated__/ProfileUpdateFormQueryRendererQuery.graphql";

type ProfileUpdateFormProps = {
  submitNavigate?: () => void;
  onDelete?: () => void;
  isOnboarding?: boolean;
};

export const ProfileUpdateForm = ({
  submitNavigate,
  onDelete,
  isOnboarding,
}: ProfileUpdateFormProps) => {
  const [clubRef, loadQuery] =
    useQueryLoader<ProfileUpdateFormQueryRendererQuery>(
      ProfileUpdateFormQueryRendererQueryString
    );

  useEffect(() => {
    loadQuery({}, { fetchPolicy: "store-and-network" });
  }, [loadQuery]);

  return (
    <Suspense fallback={<Loader />}>
      {clubRef && (
        <ProfileUpdateFormQueryRenderer
          clubRef={clubRef}
          isOnboarding={isOnboarding}
          submitNavigate={submitNavigate ? submitNavigate : () => null}
          onDelete={onDelete}
        />
      )}
    </Suspense>
  );
};
